import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { string, bool, func, shape } from "prop-types";

import { actions as assistantActions, selectors as assistantSelectors } from "reducers/assistant";

import Box from "pages/_components/Box";
import Button from "pages/_components/Button";
import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";

class LoginAssistantStepContent extends Component {
    static propTypes = {
        params: shape({
            redirect_uri: string,
            state: string,
        }).isRequired,
        _accessToken: string.isRequired,
        currentAssistant: string.isRequired,
        messengerPSID: string.isRequired,
        clientNumber: string.isRequired,
        isFromMessenger: bool.isRequired,
        isFromWhatsapp: bool.isRequired,
        dispatch: func.isRequired,
    };

    redirect = () => {
        const {
            dispatch,
            params,
            _accessToken,
            isFromMessenger,
            isFromWhatsapp,
            messengerPSID,
            clientNumber,
        } = this.props;
        let redirectUrl = decodeURIComponent(params.redirect_uri);
        if (isFromMessenger) {
            redirectUrl += `&authorization_code=${_accessToken}`;
        } else if (isFromWhatsapp) {
            redirectUrl += `?code=${_accessToken}&client_number=${clientNumber}`;
        } else {
            redirectUrl += `#access_token=${_accessToken}&token_type=bearer&state=${params.state}`;
        }
        window.location = redirectUrl;

        if (isFromMessenger) {
            dispatch(assistantActions.sendMessageToMessenger(messengerPSID, "account_linking_success"));
        }
    };

    render() {
        const { currentAssistant } = this.props;

        return (
            <Fragment>
                <form className="above-the-fold login-desktop-wrapper">
                    <Image src="images/assistants-big.svg" className="svg-image" />

                    <Box className="mb-5" display="flex" alignX="center">
                        <I18n component="h3" id="assistant.account.link.finish.subtitle" ASSISTANT={currentAssistant} />
                    </Box>

                    <Box component="ul" display="flex" alignX="center" column>
                        <I18n component="li" id="assistant.account.link.info1" />

                        <I18n component="li" id="assistant.account.link.info2" />

                        <I18n component="li" id="assistant.account.link.info3" />
                    </Box>

                    <Button className="mt-8" bsStyle="primary" label="global.continue" onClick={this.redirect} />
                </form>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    _accessToken: assistantSelectors.getAccessToken(state),
    accountLinkingToken: assistantSelectors.getAccountLinkingToken(state),
    currentAssistant: assistantSelectors.getCurrentAssistant(state),
    isAssistantLogin: assistantSelectors.isAssistantLogin(state),
    isFromMessenger: assistantSelectors.isFromMessenger(state),
    isFromWhatsapp: assistantSelectors.isFromWhatsapp(state),
    clientNumber: assistantSelectors.getClientNumber(state),
    params: assistantSelectors.getParams(state),
    messengerPSID: assistantSelectors.getMessengerPSID(state),
});

export default connect(mapStateToProps)(LoginAssistantStepContent);
